module.exports = __webpack_public_path__ + "public/img/no-order.b87d2a86.png";